import styled from "styled-components";
import { ScriptWithHighlights } from "../../../../storyboard/editor/ScriptWithHighlights";
import { TScript } from "pages/media/types/";
import { NarrationText } from "./NarrationText";

const NarrationWrapper = styled.div`
  font-size: 14px;
  color: #000;
  line-height: 1.5;
  display: block;
  font-style: italic;

  /* Horizontal breathing room so the editable's focus outline (drawn 4px
     beyond its edge via outline + offset) isn't clipped by scrollable
     ancestors. The "> div { margin: 0 }" rule below zeroes the wrapper's own
     margin in this context, which otherwise provided that room. */
  padding-inline: 6px;

  /* Override ScriptWithHighlights wrapper styles for narration card */
  > div {
    margin: 0;
    font-size: 14px;
    color: #000;
    line-height: 1.5;
    font-style: italic;
  }
`;

export const Narration = ({
  script,
  isEditable,
  index,
  onEditComplete,
  isRTL = false,
}: {
  script: string;
  isEditable: boolean;
  index: number;
  onEditComplete?: (index: number, script: Partial<TScript>) => void;
  isRTL?: boolean;
}) => {
  return (
    <NarrationText $isRTL={isRTL}>
      <NarrationWrapper>
        <ScriptWithHighlights
          script={script}
          onEditComplete={onEditComplete}
          contentEditable={isEditable}
          index={index}
        />
      </NarrationWrapper>
    </NarrationText>
  );
};
